import { v4 as uuidv4 } from "uuid";
import { DEFAULT_TASK_DURATION } from "../config"; // Assuming this path is correct
// Removed incorrect imports for TaskList and BulkTaskInput as they don't belong in a utility file.

// Creates a new task with defaults. Priority is only set if provided in data.
export function createTask(data, defaultTaskDuration = DEFAULT_TASK_DURATION) {
  const defaults = {
    id: uuidv4(),
    name: "New Task",
    duration: defaultTaskDuration,
    remaining: defaultTaskDuration,
    paused: true,
    completed: false,
    children: [],
    isRest: false,
    isDeadline: false,
    hasDeadline: false,
    deadline: null,
    tags: [],
    notes: "",
    isNew: false,
  };
  const taskInput = { ...defaults, ...data };

  if (data && data.hasOwnProperty("priority")) {
    taskInput.priority = data.priority;
  } else {
    delete taskInput.priority;
  }

  if (
    !Number.isFinite(taskInput.remaining) ||
    taskInput.remaining === undefined
  ) {
    taskInput.remaining = Number.isFinite(taskInput.duration)
      ? taskInput.duration
      : defaultTaskDuration;
  }
  return validateTask(taskInput, {
    duration: defaultTaskDuration,
    remaining: defaultTaskDuration,
  });
}

// Validates task data, applying defaults for missing fields.
export function validateTask(task, defaults = {}) {
  if (!task || typeof task !== "object") {
    throw new Error("Invalid task: must be an object");
  }
  if (!task.id) {
    task.id = uuidv4();
  }
  const defaultDuration = defaults.duration || DEFAULT_TASK_DURATION || 1800;

  let currentDuration = Number.isFinite(task.duration)
    ? task.duration
    : defaultDuration;
  let currentRemaining = Number.isFinite(task.remaining)
    ? task.remaining
    : currentDuration;

  let currentPriority = null;
  if (
    task.hasOwnProperty("priority") &&
    Number.isFinite(task.priority) &&
    task.priority >= 1 &&
    task.priority <= 5
  ) {
    currentPriority = task.priority;
  } else if (task.hasOwnProperty("priority") && task.priority === null) {
    currentPriority = null;
  }

  return {
    id: task.id,
    name: task.name || defaults.name || "Unnamed Task",
    duration: currentDuration,
    remaining: currentRemaining,
    paused: task.paused !== false,
    completed: !!task.completed,
    children: Array.isArray(task.children)
      ? task.children.map((child) => validateTask(child, defaults))
      : [],
    isRest: !!task.isRest,
    isDeadline: !!task.isDeadline,
    hasDeadline: !!task.hasDeadline,
    deadline: task.deadline || null,
    tags: Array.isArray(task.tags) ? task.tags : [],
    notes: typeof task.notes === "string" ? task.notes : "",
    isNew: !!task.isNew,
    priority: currentPriority,
  };
}

// Validates if parentId exists in tasks
export function validateParent(tasks, parentId) {
  if (!parentId) return true;
  return findTask(tasks, parentId) !== null;
}

// Finds a task by ID recursively
export function findTask(tasks, id) {
  if (!tasks || !Array.isArray(tasks)) return null;
  for (const task of tasks) {
    if (task.id === id) return task;
    if (task.children && task.children.length > 0) {
      const found = findTask(task.children, id);
      if (found) return found;
    }
  }
  return null;
}

// Finds the path to a task by ID recursively
export function findPath(tasks, targetId, path = []) {
  if (!tasks || !Array.isArray(tasks)) return [];
  for (const task of tasks) {
    if (task.id === targetId) {
      return [...path, task.id];
    }
    if (task.children && task.children.length > 0) {
      const childPath = findPath(task.children, targetId, [...path, task.id]);
      if (childPath.length > 0) return childPath;
    }
  }
  return [];
}
